'use client';

import React, { createContext, useContext, useState, useCallback } from 'react';

export interface VisualLabImage {
  id: string;
  prompt: string;
  style: string;
  ratio: string;
  platform: string;
  color: string;
  gradient: string;
  seed: number;
  created: string;
}

interface VisualLabContextValue {
  selectedImage: VisualLabImage | null;
  setSelectedImage: (image: VisualLabImage | null) => void;
  clearSelectedImage: () => void;
}

const VisualLabContext = createContext<VisualLabContextValue>({
  selectedImage: null,
  setSelectedImage: () => {},
  clearSelectedImage: () => {},
});

export function VisualLabProvider({ children }: { children: React.ReactNode }) {
  const [selectedImage, setSelectedImageState] = useState<VisualLabImage | null>(null);

  const setSelectedImage = useCallback((image: VisualLabImage | null) => {
    setSelectedImageState(image);
  }, []);

  const clearSelectedImage = useCallback(() => {
    setSelectedImageState(null);
  }, []);

  return (
    <VisualLabContext.Provider value={{ selectedImage, setSelectedImage, clearSelectedImage }}>
      {children}
    </VisualLabContext.Provider>
  );
}

export function useVisualLab() {
  return useContext(VisualLabContext);
}
